/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { MedicalSystemSubCategory } from './MedicalSystemSubCategory';
import {
    MedicalSystemSubCategoryFromJSON,
    MedicalSystemSubCategoryFromJSONTyped,
    MedicalSystemSubCategoryToJSON,
} from './MedicalSystemSubCategory';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';

/**
 * 
 * @export
 * @interface CreateOtherTreatmentMachineDto
 */
export interface CreateOtherTreatmentMachineDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOtherTreatmentMachineDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherTreatmentMachineDto
     */
    description?: string | null;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof CreateOtherTreatmentMachineDto
     */
    category: RtSystemCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof CreateOtherTreatmentMachineDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherTreatmentMachineDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherTreatmentMachineDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherTreatmentMachineDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOtherTreatmentMachineDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOtherTreatmentMachineDto
     */
    isArchived?: boolean;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateOtherTreatmentMachineDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherTreatmentMachineDto
     */
    typeSpecification?: string | null;
    /**
     * 
     * @type {MedicalSystemSubCategory}
     * @memberof CreateOtherTreatmentMachineDto
     */
    subCategory: MedicalSystemSubCategory;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherTreatmentMachineDto
     */
    serialNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherTreatmentMachineDto
     */
    $type?: CreateOtherTreatmentMachineDtoTypeEnum;
}


/**
 * @export
 */
export const CreateOtherTreatmentMachineDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoDescriptionsCreateOtherTreatmentMachineDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateOtherTreatmentMachineDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateOtherTreatmentMachineDtoTypeEnum = typeof CreateOtherTreatmentMachineDtoTypeEnum[keyof typeof CreateOtherTreatmentMachineDtoTypeEnum];


/**
 * Check if a given object implements the CreateOtherTreatmentMachineDto interface.
 */
export function instanceOfCreateOtherTreatmentMachineDto(value?: unknown): value is CreateOtherTreatmentMachineDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateOtherTreatmentMachineDtoTypeEnum)[0];
}

export function CreateOtherTreatmentMachineDtoFromJSON(json: any): CreateOtherTreatmentMachineDto {
    return CreateOtherTreatmentMachineDtoFromJSONTyped(json, false);
}

export function CreateOtherTreatmentMachineDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOtherTreatmentMachineDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'category': RtSystemCategoryFromJSON(json['category']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': !exists(json, 'subModel') ? undefined : json['subModel'],
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'isArchived': !exists(json, 'isArchived') ? undefined : json['isArchived'],
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'typeSpecification': !exists(json, 'typeSpecification') ? undefined : json['typeSpecification'],
        'subCategory': MedicalSystemSubCategoryFromJSON(json['subCategory']),
        'serialNumber': !exists(json, 'serialNumber') ? undefined : json['serialNumber'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateOtherTreatmentMachineDtoToJSON(value?: CreateOtherTreatmentMachineDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value.name,
        'description': value.description,
        'category': RtSystemCategoryToJSON(value.category),
        'manufacturer': RtSystemManufacturerToJSON(value.manufacturer),
        'model': value.model,
        'subModel': value.subModel,
        'imageId': value.imageId,
        'isAvailable': value.isAvailable,
        'isArchived': value.isArchived,
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'typeSpecification': value.typeSpecification,
        'subCategory': MedicalSystemSubCategoryToJSON(value.subCategory),
        'serialNumber': value.serialNumber,
        '$type': value.$type,
    });
}

